import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmModal = ({ show, onCancel, onConfirm, id, heading, content, type }) => {
    return (
        <>
            {/* Confirmation Modal */}
            <Modal show={show} onHide={onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>{heading} </Modal.Title>
                </Modal.Header>
                <Modal.Body>{content}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={onCancel}>Cancel</Button>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={(e) => {
                            e.preventDefault()
                            onConfirm(id, type)
                        }
                        }
                    >Confirm</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ConfirmModal;